// core
import React, { useState } from "react";

// styles
import cx from "classnames";
import styles from "./Sidebar.module.scss";
import { ClientProductTypesList } from "../../../common/interfaces/enums/ProductType";
import {
    getProductTypeAsString,
    getProductTypePage
} from "../../../common/shared/enumHelpers";
import SecurityAndPrivacyModal from "../Modals/SecurityAndPrivacyModal/SecurityAndPrivacyModal";
import Icon from "../../../common/components/Icon/Icon";
import Accordion from "../../../common/components/Accordion/Accordion";
import { getProductIntros } from "../../../common/shared/productHelpers";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import { FeatureFlag } from "../../../compare/enums/FeatureFlags";

interface ISidebar {
    onClose?: () => void;
    isDapActive?: boolean;
    className?: string;
}

enum OpenAccordionSectionEnum {
    HelpSection,
    FaqSection,
    AboutSection
}

const Sidebar: React.FC<ISidebar> = (props) => {
    const { onClose, isDapActive, className } = props;

    const [isOpenImportantInformation, setIsOpenImportantInformation] = useState(false);
    const [isOpenSecurityAndPrivacyModal, setIsOpenSecurityAndPrivacyModal] = useState(
        false
    );

    const [isOpenAccordion, setIsOpenAccordion] = useState<OpenAccordionSectionEnum>();

    const onClickAccordion = (section: OpenAccordionSectionEnum): void => {
        setIsOpenAccordion(isOpenAccordion === section ? undefined : section);
    };

    return (
        <React.Fragment>
            <ul>
                <li className={styles["list-item"]} >
                    <a className={styles["layout-nav-item"]} href="/">Home</a>
                </li>
                <li className={styles["list-item"]}>
                    <Accordion
                        headerContent={<span>Insurance</span>}
                        headerClassName={cx(
                            styles["accordion-title"],
                            styles["nav-item"]
                        )}
                        iconId={"NavAccordionBlue"}
                        iconSize={"m"}
                        arrowIconDirection={"right"}
                        openArrowDirection={"down"}
                        closedArrowDirection={"right"}
                        onClick={() =>
                            onClickAccordion(OpenAccordionSectionEnum.HelpSection)
                        }
                        isOpen={isOpenAccordion === OpenAccordionSectionEnum.HelpSection}>
                        <ul
                            className={cx(
                                "text-no-bold",
                                styles["child-container"],
                                styles["list-item"],
                                "gap-xl"
                            )}>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>Life Insurance</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/life-insurance" className={cx(styles["nav-list-link"])}>Life insurance</a></li>
                                    <li><a href="/compare/family-settings/life" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/life-insurance/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/life-insurance/life-insurance-faq.aspx" className={cx(styles["nav-list-link"])}>Life insurance FAQ</a></li>
                                    </Accordion>
                            </li>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>Health Insurance</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/health-insurance" className={cx(styles["nav-list-link"])}>Health insurance</a></li>
                                    <li><a href="/compare/family-settings/health" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/life-insurance/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/health-insurance/health-insurance-faq.aspx" className={cx(styles["nav-list-link"])}>Health insurance FAQ</a></li>
                                </Accordion>
                            </li>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>Income protection</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/income-protection">Income protection</a></li>
                                    <li><a href="/compare/family-settings/income" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/income-protection/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/income-protection/income-protection-faq.aspx" className={cx(styles["nav-list-link"])}>Income protection FAQ</a></li>
                                </Accordion>
                            </li>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>House &amp; contents Insurance</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/house-contents-insurance" className={cx(styles["nav-list-link"])}>House &amp; contents insurance</a></li>
                                    <li><a href="https://www.initio.co.nz/lifedirect" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/house-contents-insurance/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/house-contents-insurance/house-contents-insurance-faq.aspx" className={cx(styles["nav-list-link"])}>House &amp; contents FAQ</a></li>
                                </Accordion>
                            </li>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>Trauma Insurance</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/trauma-insurance" className={cx(styles["nav-list-link"])}>Trauma insurance</a></li>
                                    <li><a href="/compare/family-settings/trauma" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/trauma-insurance/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/trauma-insurance/trauma-insurance-faq.aspx" className={cx(styles["nav-list-link"])}>Trauma insurance FAQ</a></li>
                                </Accordion>
                            </li>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>Mortgage Insurance</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/mortgage-insurance" className={cx(styles["nav-list-link"])}>Mortgage insurance</a></li>
                                    <li><a href="/compare/family-settings/mortgage" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/mortgage-insurance/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/mortgage-insurance/mortgage-insurance-faq.aspx" className={cx(styles["nav-list-link"])}>Mortgage insurance FAQ</a></li>
                                </Accordion>
                            </li>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>Business Insurance</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/business-insurance" className={cx(styles["nav-list-link"])}>Business insurance</a></li>
                                    <li><a href="https://businessinsurance.lifedirect.co.nz/OccupationSelection" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/business-insurance/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/business-insurance/business-insurance-faq.aspx" className={cx(styles["nav-list-link"])}>Business insurance FAQ</a></li>
                                </Accordion>
                            </li>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>Car Insurance</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/car-insurance">Car insurance</a></li>
                                    <li><a href="https://www.coveinsurance.co.nz/lp/lifedirect" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/car-insurance/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/car-insurance/car-insurance-faq.aspx" className={cx(styles["nav-list-link"])}>Car insurance FAQ</a></li>
                                </Accordion>
                            </li>
                            <li className={styles["list-item"]}>
                                <Accordion headerContent={<span>Pet Insurance</span>}
                                    headerClassName={cx(
                                        styles["accordion-title"],
                                        styles["nav-item"]
                                    )}
                                    iconId={"NavAccordionBlue"}
                                    iconSize={"m"}
                                    arrowIconDirection={"right"}
                                    openArrowDirection={"down"}
                                    closedArrowDirection={"right"}>
                                    <li><a href="/pet-insurance" className={cx(styles["nav-list-link"])}>Pet insurance</a></li>
                                    <li><a href="https://www.coveinsurance.co.nz/lp/lifedirectpet" className={cx(styles["nav-list-link"])}>Compare quotes</a></li>
                                    <li><a href="/pet-insurance/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                                    <li><a href="/pet-insurance/pet-insurance-faq.aspx" className={cx(styles["nav-list-link"])}>Pet insurance FAQ</a></li>
                                </Accordion>
                            </li>
                        </ul>
                    </Accordion>
                    <Accordion headerContent={<span>Mortgages</span>}
                        headerClassName={cx(
                            styles["accordion-title"],
                            styles["nav-item"]
                        )}
                        iconId={"NavAccordionBlue"}
                        iconSize={"m"}
                        arrowIconDirection={"right"}
                        openArrowDirection={"down"}
                        closedArrowDirection={"right"}>
                        <li><a href="/mortgages" className={cx(styles["nav-list-link"])}>Mortgages</a></li>
                        <li><a href="/mortgages" className={cx(styles["nav-list-link"])}>Enquire now</a></li>
                        <li><a href="/mortgages/meet-the-team" className={cx(styles["nav-list-link"])}>Meet the Mortgages team</a></li>
                        <li><a href="/mortgages/mortgage-rates" className={cx(styles["nav-list-link"])}>Mortgage rates</a></li>
                        <li><a href="/mortgages/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                    </Accordion>
                    <Accordion headerContent={<span>KiwiSaver Scheme</span>}
                        headerClassName={cx(
                            styles["accordion-title"],
                            styles["nav-item"]
                        )}
                        iconId={"NavAccordionBlue"}
                        iconSize={"m"}
                        arrowIconDirection={"right"}
                        openArrowDirection={"down"}
                        closedArrowDirection={"right"}>
                        <li><a href="/kiwisaver" className={cx(styles["nav-list-link"])}>KiwiSaver scheme</a></li>
                        <li><a href="https://lifedirect.kourawealth.co.nz" className={cx(styles["nav-list-link"])}>Compare schemes</a></li>
                        <li><a href="/kiwisaver/about" className={cx(styles["nav-list-link"])}>Find out more</a></li>
                        <li><a href="/kiwisaver/kiwisaver-faq.aspx" className={cx(styles["nav-list-link"])}>KiwiSaver scheme FAQ</a></li>
                    </Accordion>
                </li>
                <div className={cx(styles["nav-links"])}>
                    <li><a href="/our-service/about-us.aspx">About us</a></li>
                    <li><a href="/about">Resources</a></li>
                    <li><a href="/calculators">Calculators</a></li>
                    <li><a href="/our-service/contact-us.aspx">Contact us</a></li>
                    <li><a href="/our-service/meet-the-team.aspx">Meet the team</a></li>
                    <li><a href="/our-service/partnerships.aspx">Partners &amp; Sponsors</a></li>
                    <li><a href="/our-service/important-information.aspx">Disclosure statements</a></li>
                    <li><a href="/our-service/complaints.aspx">Complaints</a></li>
                    <li><a href="/our-service/security-and-privacy.aspx">Security &amp; privacy</a></li>
                    <li><a href="https://my.lifedirect.co.nz"><Icon size="ml" className="space-m" id="MyLifeDirectLock"/>MyLifeDirect</a></li>
                </div>
            </ul>

        </React.Fragment>
    );
};

export default Sidebar;
